// @generated by Peggy 5.0.6.
//
// https://peggyjs.org/

import type { LocationRange, parser, ParserOptions } from 'peggy';
import type { MAAPParameter } from '../../../../../../../../types/EMRALD_Model';
import {
  type DetailsCache,
  type GrammarSource,
  peg$anyExpectation,
  peg$classExpectation,
  peg$endExpectation,
  peg$literalExpectation,
  peg$SyntaxError,
} from './peggy-util';

function peg$parse(input: string, options?: ParserOptions) {
  options = options === undefined ? {} : options;

  const peg$FAILED = {};
  const peg$source = options.grammarSource as GrammarSource | undefined;

  const peg$startRuleFunction = peg$parsestart;

  const peg$c0 = ' ';

  const peg$r0 = /^[0-9]/;
  const peg$r1 = /^[FT]/;

  const peg$e0 = peg$classExpectation([['0', '9']], false, false, false);
  const peg$e1 = peg$literalExpectation(' ', false);
  const peg$e2 = peg$classExpectation(['F', 'T'], false, false, false);
  const peg$e3 = peg$anyExpectation();

  function peg$f0(
    index: string[],
    value: 'F' | 'T',
    _: string[],
    desc: string[],
  ): MAAPParameter {
    return {
      type: 'parameter',
      desc: desc.join('').replace(/\s*$/, ''),
      index: Number(index.join('')),
      value,
    };
  }
  let peg$currPos = options.peg$currPos ?? 0;
  const peg$posDetailsCache: DetailsCache = [
    { line: 1, column: 1 },
  ];
  let peg$maxFailPos = peg$currPos;
  let peg$maxFailExpected = options.peg$maxFailExpected || [];
  const peg$silentFails = options.peg$silentFails ?? 0;

  function peg$getUnicode(pos = peg$currPos) {
    const cp = input.codePointAt(pos);
    if (cp === undefined) {
      return '';
    }
    return String.fromCodePoint(cp);
  }

  function peg$computePosDetails(pos: number) {
    let details = peg$posDetailsCache[pos];
    let p;

    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[p]) {
          p--;
        }
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details?.line ?? 0,
        column: details?.column ?? 0,
      };

      while (p < pos) {
        if (input.codePointAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(
    startPos: number,
    endPos: number,
    offset?: number,
  ) {
    const startPosDetails = peg$computePosDetails(startPos);
    const endPosDetails = peg$computePosDetails(endPos);

    const res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column,
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column,
      },
    };
    if (offset && peg$source && typeof peg$source.offset === 'function') {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected: parser.Expectation) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildStructuredError(
    expected: parser.Expectation[],
    found: string | null,
    location: LocationRange,
  ) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location,
    );
  }

  function peg$parsestart() {
    let s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r0.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e0);
      }
    }
    if (s2 === peg$FAILED) {
      s1 = peg$FAILED;
    } else {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r0.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e0);
          }
        }
      }
    }
    if (s1 === peg$FAILED) {
      peg$currPos = s0;
      s0 = peg$FAILED;
    } else {
      s2 = [];
      if (input.codePointAt(peg$currPos) === 32) {
        s3 = peg$c0;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e1);
        }
      }
      if (s3 === peg$FAILED) {
        s2 = peg$FAILED;
      } else {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (input.codePointAt(peg$currPos) === 32) {
            s3 = peg$c0;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e1);
            }
          }
        }
      }
      if (s2 === peg$FAILED) {
        peg$currPos = s0;
        s0 = peg$FAILED;
      } else {
        s3 = input.charAt(peg$currPos);
        if (peg$r1.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e2);
          }
        }
        if (s3 === peg$FAILED) {
          peg$currPos = s0;
          s0 = peg$FAILED;
        } else {
          s4 = [];
          if (input.codePointAt(peg$currPos) === 32) {
            s5 = peg$c0;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e1);
            }
          }
          if (s5 === peg$FAILED) {
            s4 = peg$FAILED;
          } else {
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              if (input.codePointAt(peg$currPos) === 32) {
                s5 = peg$c0;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e1);
                }
              }
            }
          }
          if (s4 === peg$FAILED) {
            peg$currPos = s0;
            s0 = peg$FAILED;
          } else {
            s5 = [];
            s6 = input.charAt(peg$currPos);
            if (peg$r0.test(s6)) {
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e0);
              }
            }
            while (s6 !== peg$FAILED) {
              s5.push(s6);
              s6 = input.charAt(peg$currPos);
              if (peg$r0.test(s6)) {
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e0);
                }
              }
            }
            s6 = [];
            if (input.codePointAt(peg$currPos) === 32) {
              s7 = peg$c0;
              peg$currPos++;
            } else {
              s7 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e1);
              }
            }
            while (s7 !== peg$FAILED) {
              s6.push(s7);
              if (input.codePointAt(peg$currPos) === 32) {
                s7 = peg$c0;
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e1);
                }
              }
            }
            s7 = [];
            if (input.length > peg$currPos) {
              s8 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s8 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            while (s8 !== peg$FAILED) {
              s7.push(s8);
              if (input.length > peg$currPos) {
                s8 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s8 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e3);
                }
              }
            }
            s0 = peg$f0(
              s1 as string[],
              s3 as 'F' | 'T',
              s5 as string[],
              s7 as string[],
            );
          }
        }
      }
    }

    return s0;
  }

  const peg$result = peg$startRuleFunction();

  const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
  function peg$throw() {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos),
    );
  }
  if (options.peg$library) {
    return /** @type {any} */ {
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos,
      peg$success,
      peg$throw: peg$success ? undefined : peg$throw,
    };
  }
  if (peg$success) {
    return peg$result;
  } else {
    peg$throw();
  }
}

const peg$allowedStartRules = ['start'];

export { peg$parse as parse, peg$allowedStartRules as StartRules };

export { peg$SyntaxError as SyntaxError } from './peggy-util';
